import { Card } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ButtonDefault from "~/src/components/Button/ButtonDefault";
import { useStateful } from "~/src/hooks/useStateful";
import { ArtButtons } from "../../components/Button/ArtButtons";
import { ArtType } from "../../helpers/types";

export default function VelgArt(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedArt = useStateful<ArtType | undefined>(undefined);

  const onStartButtonClick = (art: ArtType | undefined) => {
    if (art === undefined) return;
    let path = "";
    switch (art) {
      case ArtType.Elg:
        path = "/registrering/elg";
        break;
      case ArtType.Hjort:
        path = "/registrering/hjort";
        break;
      case ArtType.Rådyr:
        path = "/registrering/radyr";
        break;
      case ArtType.Villrein:
        path = "/registrering/villrein";
        break;
      default:
        throw new Error(`registrering for ${art} not implemented`);
    }
    navigate(path, { state: { valgtArt: art } });
  };

  return (
    <Card className="h-full min-h-fit shadow-none  text-ldir-brown-900 rounded-none bg-ldir-brown-300 flex flex-col justify-between">
      <div>
        <h2 className="text-2xl font-serif font-bold m-4 mt-6">
          {t("pages.registrering.subtitle")}
        </h2>
        <ArtButtons onClick={(e: ArtType) => selectedArt.set(e)} />
      </div>

      <div className="m-4 mb-10">
        <ButtonDefault
          disabled={selectedArt.value == undefined}
          id="start"
          label={t("pages.registrering.start")}
          onClick={() => onStartButtonClick(selectedArt.value)}
          icon={
            <svg
              role="graphics-symbol"
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="currentColor"
            >
              <path
                d="M11 15.4L15.4 11L11 6.6L9.46 8.14L11.22 9.9H6.6V12.1H11.22L9.46 13.86L11 15.4ZM11 22C9.47833 22 8.04833 21.7112 6.71 21.1337C5.37167 20.5562 4.2075 19.7725 3.2175 18.7825C2.2275 17.7925 1.44375 16.6283 0.86625 15.29C0.28875 13.9517 0 12.5217 0 11C0 9.47833 0.28875 8.04833 0.86625 6.71C1.44375 5.37167 2.2275 4.2075 3.2175 3.2175C4.2075 2.2275 5.37167 1.44375 6.71 0.86625C8.04833 0.28875 9.47833 0 11 0C12.5217 0 13.9517 0.28875 15.29 0.86625C16.6283 1.44375 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5562 5.37167 21.1337 6.71C21.7112 8.04833 22 9.47833 22 11C22 12.5217 21.7112 13.9517 21.1337 15.29C20.5562 16.6283 19.7725 17.7925 18.7825 18.7825C17.7925 19.7725 16.6283 20.5562 15.29 21.1337C13.9517 21.7112 12.5217 22 11 22ZM11 19.8C13.4567 19.8 15.5375 18.9475 17.2425 17.2425C18.9475 15.5375 19.8 13.4567 19.8 11C19.8 8.54333 18.9475 6.4625 17.2425 4.7575C15.5375 3.0525 13.4567 2.2 11 2.2C8.54333 2.2 6.4625 3.0525 4.7575 4.7575C3.0525 6.4625 2.2 8.54333 2.2 11C2.2 13.4567 3.0525 15.5375 4.7575 17.2425C6.4625 18.9475 8.54333 19.8 11 19.8Z"
                fill="currentColor"
              />
            </svg>
          }
        />
      </div>
    </Card>
  );
}
